import React, { useRef, useState } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";

export const ImprimirControlVacios = (props) => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const txtDetallado = useRef(false);
  const txtGeneral = useRef(false);
  const txtBasico = useRef(false);
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const btnSalir = useRef();
  const txtTodasFechas = useRef();
  const txtTodosCliente = useRef();
  const txtTodosAlmacenes = useRef();
  const txtPorAlamacen = useRef();
  const txtAlamacen = useRef();
  const txtPorCliente = useRef();
  const txtIdProducto = useRef();
  const txtRifrespon = useRef();
  const txtNomrespon = useRef();
  const txtRifVende = useRef();
  const txtNomVende = useRef();
  const txtTipoVacio = useRef();
  const txtDesde = useRef();
  const txtHasta = useRef();
  const txtCbmrif = useRef();
  const txtCbmrifVende = useRef();
  const txtTodosVendedores = useRef();
  const txtPorVendedor = useRef();
  const [idclienteDetalle, setIdClienteDetalle] = useState("");
  const [dataestatus, setDataestatus] = useState("");
  const [combocliente, setCombocliente] = useState(0);
  const [valvende, setValvende] = useState(0);
  const [tiporif, setTipofic] = useState("V");
  const [mostrar1, setMostrar1] = useState(null);
  const [desde, setDesde] = useState("");
  const [hasta, setHasta] = useState("");
  const [clientvende, setClientvende] = useState("");
  const [idclient, setIdclient] = useState("");
  const [idvendedr, setIdvendedr] = useState("");
  const [datafecha, setDatafecha] = useState("");
  const [activate, setActivate] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [tipovacio, setTipovacio] = useState([]);
  const [almacenes, setAlmacenes] = useState([]);
  const [actial, setActial] = useState(0);
  const [paraalmacen, setParaalmacen] = useState("");
  const [paratipovacio, setParatipovacio] = useState("");
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [truefecha, setTruefecha] = useState(true);

  const blanquear = () => {
    setActivate(false);
    setDataestatus("");
    setIdclient("");
    setIdvendedr("");
    setDatafecha("");
    setValvende(0);
    setCombocliente(0);
    setTipofic("V");
    setTruefecha(true);
    setDesde("");
    setHasta("");
    setTipovacio([]);
    setParatipovacio("");
    setParaalmacen("");
    setAlmacenes([]);
    setActial(0);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {
      if (txtDesde.current.value === "" || txtHasta.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Seleccione las Fechas a Consultar !",
          icono: "informacion",
        });
        if (txtDesde.current.value === "" && txtHasta.current.value !== "") {
          txtDesde.current.focus();
        } else if (
          txtHasta.current.value === "" &&
          txtDesde.current.value !== ""
        ) {
          txtHasta.current.focus();
        } else {
          txtDesde.current.focus();
        }
        sigue = false;
      } else if (
        txtPorCliente.current.checked === true &&
        txtRifrespon.current.value === ""
      ) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Introduzca el RIF del Cliente a Consultar !",
          icono: "informacion",
        });
        txtRifrespon.current.focus();
        sigue = false;
      } else if (sigue !== false) {
        if (txtDetallado && txtDetallado.current.checked) {
          imprimirDetallado();
        } else if (txtGeneral && txtGeneral.current.checked) {
          imprimirGeneral();
        } else {
          imprimirBasico();
        }
      }
    }
  };

  const onChekval = (e) => {
    if (e.target.id === "cliente") {
      if (txtTodosCliente.current.checked === true) {
        setCombocliente(0);
        setIdclient("");
        txtNomrespon.current.value = "";
        txtRifrespon.current.value = "";
        txtCbmrif.current.value = "";
      } else {
        setCombocliente(1);
        setClientvende("cliente");
      }
    } else if (e.target.id === "vendedor") {
      if (txtTodosVendedores.current.checked === true) {
        setValvende(0);
        setIdvendedr("");
        txtNomVende.current.value = "";
        txtCbmrifVende.current.value = "";
        txtRifVende.current.value = "";
      } else {
        setValvende(1);
        setClientvende("vendedor");
      }
    } else if (e.target.name === "todasfechas") {
      if (e.target.checked === false) {
        let fechas = " and nv.fecha between " + "'";
        setDatafecha(fechas);
        setTruefecha(false);
      } else {
        txtDesde.current.value = moment(fechasistema).format("YYYY-MM-DD");
        setDatafecha("");
        setTruefecha(true);
      }
    } else if (e.target.name === "almacen") {
      if (txtTodosAlmacenes.current.checked === true) {
        setActial(0);
        setAlmacenes([]);
      } else {
        setActial(1);
        seleccionarRegistrosAlmacen();
      }
    }
  };

  const imprimirGeneral = () => {
    let condiciones = [];
    if (paratipovacio !== '') {
      condiciones.push(
        `and nd.idclasevacio = ${paratipovacio}`
      );
    }
    if (paraalmacen !== '') {
      condiciones.push(
        `and n.idalmacen = ${paraalmacen}`
      );
    }
    if (!txtTodosCliente.current.checked) {
      condiciones.push(
        `and n.idcliente = ${idclienteDetalle}`
      );
    }
    if (!txtTodasFechas.current.checked) {
      condiciones.push(`and n.fecha between ${desde} AND ${hasta}`);
    }
    const condi = condiciones.join(" ");
    window.open(
      op.reportes +
      `/almacen?afiliado=${afiliado}&reporte=ReporteDeudaVacios&condi=${condi}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirDetallado = () => {
    let condiciones = [];
    if (paratipovacio !== '') {
      condiciones.push(
        `oiv.idclasevacio = ${paratipovacio}`
      );
    }
    if (paraalmacen !== '') {
      condiciones.push(
        `n.idalmacen = ${paraalmacen}`
      );
    }
    if (!txtTodosCliente.current.checked) {
      condiciones.push(
        `n.idcliente = ${idclienteDetalle} OR n.idvendedor = ${idclienteDetalle}`
      );
    }
    if (!txtTodasFechas.current.checked) {
      condiciones.push(`n.fecha between ${desde} AND ${hasta}`);
    }
    const condi = condiciones.join(" AND ");
    window.open(
      op.reportes +
      `/almacen?afiliado=${afiliado}&reporte=ReporteDiarioVacio&condi=${condi}`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const imprimirBasico = () => {
    let paratipov = paratipovacio !== '' ? "and nvd.idclasevacio = " + paratipovacio : "";
    let paraalm = paraalmacen !== '' ? "and nv.idalmacen = " + paraalmacen : "";
    var reporte = "ReporteControldeVacios";
    let valcli = datafecha !== "" ? "" : "'";
    let dfechas =
      datafecha !== ""
        ? datafecha +
        "|| quote_literal(" +
        desde +
        ") ||" +
        "'" +
        " and " +
        "'" +
        "|| quote_literal(" +
        hasta +
        ")"
        : "";
    let condi = "'" + idclient + paratipov + paraalm + valcli + dfechas;
    let opera = 2;

    window.open(
      op.reportes +
      "/almacen?afiliado=" +
      afiliado +
      "&reporte=" +
      reporte +
      "&ope=" +
      opera +
      "&condi=" +
      condi,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cerrarModal = () => {
    if (props.llamado === 2) {
      props.onHideRenderizar();
      props.onHideCancela();
    }
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const handleAceptaCliente = (values) => {
    setMostrar1(false);

    if (clientvende === "cliente") {
      txtCbmrif.current.value = values.rif.substring(0, 1);
      txtRifrespon.current.value = values.rif.substring(1, 11);
      txtNomrespon.current.value = values.nombre;
      setIdclient(" and nv.idcliente = " + values.idagente);
      setIdClienteDetalle(values.idagente);
      // selectResponsable(values.rif);
    } else if (clientvende === "vendedor") {
      txtCbmrifVende.current.value = values.rif.substring(0, 1);
      txtRifVende.current.value = values.rif.substring(1, 11);
      txtNomVende.current.value = values.nombre;
      selectResponsable(values.rif);
    }
  };

  const catalogoClienteVendedor = (ope) => (e) => {
    e.preventDefault();
    if (ope === 1) {
      setClientvende("cliente");
      setMostrar1(true);
    } else {
      setClientvende("vendedor");
      setMostrar1(true);
    }
  };

  const selectResponsable = (id) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = clientvende;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            setIdClienteDetalle(response.data.idagente);
            if (clientvende === "cliente") {
              txtNomrespon.current.value = response.data.nombre;
              setIdclient(" and nv.idcliente = " + response.data.idagente);
              btnAcepta.current.focus();
            } else {
              txtNomVende.current.value = response.data.nombre;
              setIdvendedr(" and n.idvendedor = " + response.data.idagente);
              btnAcepta.current.focus();
            }
          } else {
            if (clientvende !== "vendedor") {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "¡ RIF y/o Cliente no Registrado !",
                icono: "informacion",
              });
              txtRifrespon.current.value = "";
              txtNomrespon.current.value = "";
            } else {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "¡ RIF y/o Vendedor no Registrado !",
                icono: "informacion",
              });
              txtRifVende.current.value = "";
              txtNomVende.current.value = "";
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChange = (e) => {
    if (e.target.name === "nci") {
      setTipofic(e.target.value);
    } else if (e.target.name === "desde") {
      if (e.target.value > moment(fechasistema).format("YYYY-MM-DD")) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto:
            "¡ La Fecha seleccionada no puede ser Mayor a la Fecha Actual !",
          icono: "informacion",
        });
        txtDesde.current.value = moment(fechasistema).format("YYYY-MM-DD");
        txtDesde.current.focus();
      } else {
        setDesde("'" + moment(e.target.value).format("DD-MM-YYYY") + "'");
      }
    } else if (e.target.name === "hasta") {
      setHasta("'" + moment(e.target.value).format("DD-MM-YYYY") + "'");
    } else if (e.target.name === "tipo") {
      if (e.target.value === "0") {
        setParatipovacio("");
      } else {
        setParatipovacio(e.target.value);
      }
    } else if (e.target.name === "almacen") {
      if (e.target.value === "0") {
        setParaalmacen("");
      } else {
        setParaalmacen(e.target.value);
      }
    }
  };

  const handleCliente = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        setClientvende("cliente");
        if (clientvende === "cliente") {
          selectResponsable(tiporif + e.target.value);
        }
      }
    }
  };

  const handleVendedor = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        setClientvende("vendedor");
        if (clientvende === "vendedor") {
          selectResponsable(tiporif + e.target.value);
        }
      }
    }
  };

  const seleccionarRegistros = () => {

    let campos = "*";
    let nomtab = "clasevacio";
    let condi = '1=1';
    let orden = "idclasevacio";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setTipovacio(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarRegistrosAlmacen = () => {

    let campos = "*";
    let nomtab = "almacen";
    let condi = '1=1';
    let orden = "idalmacen";
    let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setAlmacenes(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {
          seleccionarRegistros();
          txtDesde.current.value = moment(fechasistema).format("YYYY-MM-DD");
          txtHasta.current.value = moment(fechasistema).format("YYYY-MM-DD");
          let desdec = moment(fechasistema).format("DD-MM-YYYY");
          let hastac = moment(fechasistema).format("DD-MM-YYYY");
          setDesde("'" + desdec + "'");
          setHasta("'" + hastac + "'");
          txtTodosCliente.current.checked = true;
          txtPorCliente.current.checked = false;
          txtTodasFechas.current.checked = true;
          setHabilitado(false);
          let data = " and rp.status != 4";
          setDataestatus(data);
          txtBasico.current.checked = true;
          txtGeneral.current.checked = false;
          txtDetallado.current.checked = false;
          txtTodosAlmacenes.current.checked = true;
          txtPorAlamacen.current.checked = false;
        } else {
          txtBasico.current.checked = false;
          txtGeneral.current.checked = false;
          txtDetallado.current.checked = false;
          txtTodosCliente.current.checked = false;
          txtPorCliente.current.checked = false;
          txtTodasFechas.current.checked = false;
          setHabilitado(true);
          setDataestatus("");
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold" style={{ color: "#fff" }}>
          <h3>Imprimir Control de Vacios</h3>
        </div>

        <a href="#" ref={btnSalir} onClick={cancelar} className="text-light">
          <i className="fas fa-times fa-1x shadow"> {/* Salir */}</i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>cargando...</Loader>
        </Dimmer>
        <div className="col-md-12 row mx-auto px-0">
          <div className="row col-md-12 rounded mx-auto">
            <div className="col-12 mb-2 px-2 d-flex justify-content-end">
              <div className="form-check form-check-inline col-3">
                <input className="form-check-input" ref={txtBasico} type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                <label className="form-check-label" for="inlineRadio1">Basico</label>
              </div>
              <div className="form-check form-check-inline col-3">
                <input className="form-check-input" ref={txtGeneral} type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                <label class="form-check-label" for="inlineRadio2">General</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" ref={txtDetallado} type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3" />
                <label class="form-check-label" for="inlineRadio3">Detallado</label>
              </div>
            </div>
            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
              <legend className="float-none m-0 w-auto fs-4 fw-bold">
                Fecha:
              </legend>

              <div className="col-12 d-flex justify-content-center px-0 row m-0">
                <div className="col-1 px-1">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      ref={txtTodasFechas}
                      onChange={onChekval}
                      name="todasfechas"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label className="form-check-label" for="flexCheckDefault">
                      Todos
                    </label>
                  </div>
                </div>

                <div className="col-3 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DESDE:
                    </label>
                    <input
                      type="date"
                      ref={txtDesde}
                      disabled={truefecha}
                      name="desde"
                      onChange={onChange}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div className="col-3 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      HASTA:
                    </label>
                    <input
                      type="date"
                      ref={txtHasta}
                      disabled={truefecha}
                      name="hasta"
                      onChange={onChange}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>

                <div className="col-5 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO DE VACIO:{" "}
                    </label>
                    <select
                      ref={txtTipoVacio}
                      name="tipo"
                      onChange={onChange}
                      className="form-select form-select-sm text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="0">--TODOS--</option>
                      {tipovacio.map((item2, x) => (
                        <option key={x} value={item2.idclasevacio}>
                          {" "}
                          {item2.descripcion}{" "}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
              <legend className="float-none m-0 w-auto fs-4 fw-bold">
                Cliente:
              </legend>

              <div className="col-2 mx-auto">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    name="cliente"
                    value="1"
                    ref={txtTodosCliente}
                    onChange={onChekval}
                    id="cliente"
                    type="radio"
                  />
                  <label className="form-check-label" for="exampleRa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className="col-2 mx-auto">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    name="cliente"
                    value="2"
                    ref={txtPorCliente}
                    onChange={onChekval}
                    id="cliente"
                    type="radio"
                  />
                  <label className="form-check-label" for="exampleRa2">
                    Por Cliente
                  </label>
                </div>
              </div>

              <input type="hidden" ref={txtIdProducto} />

              <div className="col-7 mr-auto px-0">
                <div className="input-group input-group-sm col-7 px-1 ml-auto">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    RIF:
                  </label>
                  <select
                    className="form-select col-3"
                    ref={txtCbmrif}
                    name="nci"
                    onChange={onChange}
                    aria-label="Default select example"
                  >
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="G">G</option>
                  </select>
                  <input
                    type="text"
                    ref={txtRifrespon}
                    disabled={combocliente === 1 ? false : true}
                    onKeyUp={handleCliente}
                    onBlur={handleCliente}
                    className="form-control text-uppercase"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <button
                    disabled={combocliente === 1 ? false : true}
                    type="button"
                    onClick={catalogoClienteVendedor(1)}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <div className="col-12 row m-0 py-3">
                <div className="col-12">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre del Cliente:
                    </label>
                    <input
                      type="text"
                      ref={txtNomrespon}
                      disabled={true}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                </div>
              </div>
            </fieldset>

            <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
              <legend className="float-none m-0 w-auto fs-4 fw-bold">
                Almacén:
              </legend>

              <div className="col-2 mx-auto">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    name="almacen"
                    value="1"
                    ref={txtTodosAlmacenes}
                    onChange={onChekval}
                    id="almacen"
                    type="radio"
                  />
                  <label className="form-check-label" for="exampleRaa1">
                    Todos
                  </label>
                </div>
              </div>

              <div className="col-2 mx-auto">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    name="almacen"
                    value="2"
                    ref={txtPorAlamacen}
                    onChange={onChekval}
                    id="almacen"
                    type="radio"
                  />
                  <label className="form-check-label" for="exampleRaa2">
                    Por Almacén
                  </label>
                </div>
              </div>

              <div className="col-5 px-1">
                <div className="input-group input-group-sm">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    ALMACÉN:{" "}
                  </label>
                  <select
                    disabled={actial !== 0 ? false : true}
                    ref={txtAlamacen}
                    name="almacen"
                    onChange={onChange}
                    className="form-select form-select-sm text-center"
                    aria-label=".form-select-sm example"
                  >
                    <option value="0">--TODOS--</option>
                    {almacenes.map((item2, x) => (
                      <option key={x} value={item2.idalmacen}>
                        {" "}
                        {item2.descripcion}{" "}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="row m-0 col-md-12 mx-auto">
          <div className="col-md-4 ml-auto px-0 m-0 d-flex justify-content-end">
            <button
              ref={btnAcepta}
              disabled={habilitado}
              onClick={onChangeValidar}
              className="btn btn-sm rounded-pill btn-primary mx-1"
            >
              <i className="fas fa-print"> Imprimir</i>
            </button>
            <button
              ref={btnCancela}
              onClick={cancelar}
              className="btn btn-danger btn-sm rounded-pill mx-1"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>

      <CatalogoCliente
        show={mostrar1}
        nomid="vacio"
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaCliente}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/vacios/modalImprimirControlVacios.js